import { useEffect, useState } from "react";
import DateComparisonDropdown from "../../dropdowns/dateComparison.dropdown.advancedQuery";

const FORM_FIELDS = {
  comparison: "between",
  dateValue: "",
  secondValue: "",
};

const DateInput = ({ field: { label, value } = {}, setMatch = () => {} }) => {
  const [formFields, setFormFields] = useState(FORM_FIELDS);
  const { comparison, dateValue, secondValue } = formFields;
  const handleChange = ({ target: { name, value } }) => {
    setFormFields((prevFields) => ({ ...prevFields, [name]: value }));
  };
  const updateFormFieldsBasedOnComparison = () => {
    let updates = {};
    if (secondValue && secondValue < dateValue) {
      updates.secondValue = dateValue;
    }
    if (comparison !== "between" && secondValue) {
      updates.secondValue = "";
    }
    setFormFields((prevFields) => ({ ...prevFields, ...updates }));
  };
  const updateMatch = () => {
    const comparisonOps = {
      lt: { $lt: dateValue },
      gt: { $gt: dateValue },
      between: { $gt: dateValue, $lt: secondValue },
    };
    const operation = comparisonOps[comparison] || dateValue;

    setMatch((prevMatch) => {
      const [key, matchValue] = Object.entries(prevMatch)[0];
      return {
        [key]: matchValue.map((fieldVal) =>
          value === Object.keys(fieldVal)[0]
            ? { [Object.keys(fieldVal)[0]]: operation }
            : fieldVal
        ),
      };
    });
  };

  useEffect(updateFormFieldsBasedOnComparison, [
    dateValue,
    secondValue,
    comparison,
  ]);
  useEffect(updateMatch, [formFields]);

  return (
    <div className="justify-between bg-slate-100 p-2 flex-wrap gap-2 flex flex-row shadow shadow-secondary">
      <h3 className="font-bold">{label}:</h3>
      <div className="flex-wrap flex flex-row gap-2">
        <DateComparisonDropdown
          handleChange={handleChange}
          name="comparison"
          value={comparison}
        />
        <input
          type="date"
          onChange={handleChange}
          name="dateValue"
          value={dateValue}
          className="w-32 rounded px-2 shadow shadow-secondary"
        />
        {comparison === "between" && (
          <div className="flex flex-row gap-2">
            <label className="px-2 rounded shadow shadow-secondary">{`< ${label} <`}</label>
            <input
              type="date"
              onChange={handleChange}
              placeholder="Enter a value..."
              name="secondValue"
              value={secondValue}
              className="w-32 rounded px-2 shadow shadow-secondary"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DateInput;
